import { Tooltip } from '@/components/ui/tooltip.tsx'
import { classNames } from '@/utils/helpers.ts'

export const StatusIndicator = ({
  size = 'medium',
  pulse = true,
  colorClassName,
  tooltipContent,
}: {
  colorClassName: string
  tooltipContent: string
  pulse?: boolean
  size?: 'small' | 'medium'
}) => {
  const sizeClassName = size === 'small' ? 'h-1.5 w-1.5' : 'h-3 w-3'

  return (
    <Tooltip
      content={tooltipContent}
      className="hover:cursor-default"
    >
      <span className={classNames('relative flex', sizeClassName)}>
        {pulse && (
          <span
            className={classNames(
              'absolute inline-flex h-full w-full animate-ping-slow rounded-full opacity-75',
              colorClassName,
              sizeClassName,
            )}
          />
        )}
        <span
          className={classNames(
            'relative inline-flex rounded-full',
            colorClassName,
            sizeClassName,
          )}
        />
      </span>
    </Tooltip>
  )
}
